import React, {Component} from 'react'
import {Input, Row, Col, Modal, Spin, Avatar, Button, Tabs, Empty, message, Checkbox } from 'antd';
import uploadIcon from '../../components/upload/upload.png';
import {connect} from "react-redux";
import {NewsActivityReporterTable} from "../../components/interview/NewsActivityReporter";
import {getReporterList} from "../../actions/interview";
import {Scrollbars} from "react-custom-scrollbars";
import "./newsActivity.css"

const { Search } = Input;
const { TabPane } = Tabs;
class NewsActivitySelectReporter extends Component {

    state = {
        tabs : [{title:"新闻中心记者",key:"xwzxjz",active:true},
        {title:"学生记者",key:"xsjz"},
        {title:"供稿/图/视频",key:"ggtsp"}],
        interviewJointers:this.props.data.interviewJointers,
        reporterModelVisible:false,
        reporterModelTitle:""
    };

    changeTab(key){
        if(key){
            this.setState(prevState=>{
                prevState.tabs.map(item=>{
                    item.active = item.key === key;
                });
                return prevState;
            })
        }
    }
    componentDidMount(){
        this.props.onRef(this);//将组件实例this传递给onRef方法
    }

    constructor(props) {
        super(props);
    }

    render() {
        return <div style={{padding:"20px 30px"}}>
            <div style={{height:'50px',marginBottom:"20px"}}>
                <Row style={{height:'50px'}}>
                    <Col span={24} style={{height:'50px'}}>
                        <SelectReporterBtn icon={uploadIcon} name={"选择记者"} style={{float:"left"}} onClick={()=>{
                            this.setState({
                                reporterModelVisible:true,
                                reporterModelTitle:"选择记者"
                            })
                        }}/>
                    </Col>
                </Row>
                <div style={{clear:"both"}}></div>
            </div>
            <NewsActivityReporterTable data={{interviewJointers:this.state.interviewJointers}} edit={true}
                                       onChange={(dataSource)=>{
                                           let interviewJointers = [];
                                           dataSource.map(data=>{
                                               if(data.roles && data.roles.length > 0){
                                                   data.roles.map(role=>{
                                                       interviewJointers.push({
                                                           account: data.account,
                                                           difficulty: data.difficulty?data.difficulty:"",
                                                           interviewRole: role,
                                                           jointerName: data.name,
                                                           name: data.name,
                                                           manager: 0,
                                                           photoUrl: data.photoUrl,
                                                           properties: data.roleRroperties["type_"+role],
                                                       })
                                                   });
                                               }else{
                                                   interviewJointers.push({
                                                       account: data.account,
                                                       difficulty: data.difficulty?data.difficulty:"",
                                                       interviewRole: undefined,
                                                       jointerName: data.name,
                                                       name: data.name,
                                                       manager: 0,
                                                       photoUrl: data.photoUrl,
                                                       properties: undefined,
                                                   })
                                               }
                                           });
                                           this.setState({
                                               interviewJointers
                                           })
                                           //dataSource:  [
                                           // {"key":0,"account":"zxjsjz1","name":"zxjsjz1","sex":1,"photoUrl":"","roles":["1","2","4"],"difficulty":3,"roleRroperties":{"type_2":1,"type_1":1},"status":0},
                                           // {"key":1,"account":"zxjsjz3","name":"zxjsjz3","sex":1,"photoUrl":"","roles":["2","4"],"roleRroperties":{"type_2":2},"status":0},
                                           // {"key":2,"account":"zxxsjz2","name":"zxxsjz2","sex":1,"photoUrl":"","roles":["1","3","4"],"difficulty":1,"roleRroperties":{"type_3":3,"type_1":1},"status":0}]
                                       }}
                                       btns={(text, record)=><span
                style={{cursor:"pointer"}}
                onClick={()=>{
                this.setState(prevState=>{
                    prevState.interviewJointers = prevState.interviewJointers.filter(jointer=>{
                        return record.account != jointer.account;
                    });
                    return prevState;
                });
            }}>删除</span>} />
            <SelectReporterModal
                reporterModelTitle={this.state.reporterModelTitle}
                reporterModelVisible={this.state.reporterModelVisible}
                tabs={this.state.tabs}
                onTabClick={(key, e)=>{
                    this.changeTab(key);
                }}
                checkedUsers={this.state.interviewJointers?this.state.interviewJointers:[]}
                interviewId={this.props.data.interviewId}
                startDate={this.props.data.startDate}
                sysConfig={this.props.sysConfig}
                onOk={(checkedUsers)=>{
                    this.setState(prevState=>{
                        let _interviewJointers = [];
                        if(prevState.interviewJointers){
                            prevState.interviewJointers.map(jointer=>{
                                let isPush = false;
                                checkedUsers && checkedUsers.map(user=>{
                                    if(jointer.account === user.account){
                                        if(!jointer.jointerName && user.name){
                                            jointer.jointerName = user.name;
                                        }
                                        isPush = true;
                                    }
                                });
                                if(isPush){
                                    _interviewJointers.push(JSON.parse(JSON.stringify(jointer)));
                                }
                            });
                        }else{
                            checkedUsers && checkedUsers.map(user=>{
                                user.jointerName = user.name;
                            });
                            _interviewJointers = Object.assign([], checkedUsers);
                        }
                        prevState.interviewJointers = _interviewJointers;
                        prevState.reporterModelVisible = false;
                        return prevState;
                    });
                }}
                onCancel={()=>{
                    this.setState({
                        reporterModelVisible:false,
                        tabs : [{title:"新闻中心记者",key:"xwzxjz",active:true},
                            {title:"学生记者",key:"xsjz"},
                            {title:"供稿/图/视频",key:"ggtsp"}],
                        })
                    }}
            />
        </div>
    }
}

class SelectReporterModal extends Component{

    state={
        searchReporterName:""
    };

    loadOver = true;//列表在加载中

    checkedUsers = this.props.checkedUsers;

    componentWillReceiveProps(nextProps, nextContext) {
        this.checkedUsers = nextProps.checkedUsers;
    }

    getTabActiveProp(prop){
        let propValue = "";
        this.props.tabs.map(item=>{
            if(item.active && !propValue){
                propValue = item[prop]
            }
        });
        return propValue;
    };

    render() {
        return <Modal
            width={"750px"}
            title={this.props.reporterModelTitle}
            maskClosable={false}
            footer={<Button type={"primary"} onClick={()=>{
                this.props.onOk(this.checkedUsers);
            }} >确定</Button>}
            closable={false}//这里选择记者这里最好设置为不显示，如果有别的需求，可以该为默认为false
            onCancel={this.props.onCancel}
            bodyStyle={{backgroundColor: "#f4f6fc"}}
            visible={this.props.reporterModelVisible}>
            <div style={{padding:"15px 20px",backgroundColor: "#ffffff"}}>
                <table width={"100%"} cellPadding={0} cellSpacing={0} border={0} style={{marginBottom:"15px"}}>
                    <tbody>
                    <tr>
                        <td width={381}>
                            <Tabs size={"small"}
                                  onTabClick={(key, e)=>{
                                      if(!this.loadOver){
                                          message.warn("等待加载完毕之后再切换");
                                      }else{
                                          this.props.onTabClick(key, e);
                                      }
                                  }}
                                  activeKey={this.getTabActiveProp("key")}
                            >
                                {this.props.tabs.map(item=>{
                                    return <TabPane tab={item.title} key={item.key}/>
                                })}
                            </Tabs></td>
                        <td align={"right"}>
                            <Search
                                placeholder="请输入搜索内容"
                                enterButton={true}
                                onSearch={searchReporterName => this.setState({
                                    searchReporterName
                                })}
                                style={{ width: 200 }}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
                <SelectReporterModalContent
                    onChange={(checkedUsers)=>{
                        this.checkedUsers = checkedUsers;
                    }}
                    loadBegin={()=>{
                        this.loadOver = false;
                    }}
                    loadOver={()=>{
                        this.loadOver = true;
                    }}
                    checkedUsers={this.checkedUsers}
                    prop={this.getTabActiveProp("title")}
                    searchReporterName={this.state.searchReporterName}
                    interviewId={this.props.interviewId}
                    startDate={this.props.startDate}
                    endDate={(()=>{
                        let defaultTime = 24 * 60 * 60 * 1000;//默认延长一天
                        let extendTime = defaultTime;
                        if(this.props.sysConfig){
                            extendTime = eval(this.props.sysConfig.getValueByKey("new.activity.start.extend.time", defaultTime));
                        }
                        let startDate = new Date();
                        if(this.props.startDate){
                            startDate = new Date(this.props.startDate);
                        }
                        return window.formatDate(new Date(startDate.getTime()+ extendTime));
                    })()}
                />
            </div>
        </Modal>
    }
}

SelectReporterModal.defaultProps = {
    checkedUsers:[]
};

class SelectReporterModalContent extends Component{

    state = {
        checkedUsers:[],
        data:[],
        total:0,
        load:false,
        over:false//是否已经全部加载完毕
    };

    defaultStart = 1;
    current = this.defaultStart;

    columns = [
        {
            title: '记者',
            dataIndex: 'user.name',
            key: 'user.name',
            className:"newTableContentBoldText textPointer textLeft",
            span:8,
            render:(text, record)=>{
                let sex = record.user.sex;
                let photo = "images/header_boys.png";
                if(record.user.photoUrl){
                    photo = record.user.photoUrl
                }else{
                    if(sex === 2){
                        photo = "/cm-sites/images/header_girls.png";
                    }
                }
                return <span><Avatar src={photo} style={{marginRight:"10px"}} size={35} />{record.user?record.user.name:""}</span>
            }
        },
        {
            title: '未领取',
            dataIndex: 'noGetCount',
            key: 'noGetCount',
            span:3,
            render:(text, record)=>{
                return <span>{record.statistics?record.statistics.noGetCount:0}</span>
            }
        },
        {
            title: '进行中',
            dataIndex: 'underwayCount',
            key: 'underwayCount',
            span:3,
            render:(text, record)=>{
                return <span>{record.statistics?record.statistics.underwayCount:0}</span>
            }
        },
        {
            title: '已完成',
            dataIndex: 'overCount',
            key: 'overCount',
            span:3,
            render:(text, record)=>{
                return <span>{record.statistics?record.statistics.overCount:0}</span>
            }
        },
        {
            title: '是否冲突',
            dataIndex: 'conflict',
            key: 'conflict',
            span:4,
            render:(text, record)=>{
                return <span>{(record.user&&record.user.conflict) === 1? "是" : "否"}</span>
            }
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            span:3,
            render:(text, record)=>{
                return <Checkbox onChange={(e)=>{
                    this.setState(prevState=>{
                        if(e.target.checked){
                            let isPush = true;
                            prevState.checkedUsers.map(u =>{
                                if(u.account === record.account && (u.interviewRole == record.u.interviewRole) ){
                                    isPush = false
                                }
                            });
                            if(isPush){
                                prevState.checkedUsers.push(record.user);
                            }
                        }else{
                            prevState.checkedUsers = prevState.checkedUsers.filter(user=>{
                                return record.user.account !== user.account;
                            })
                        }
                        this.props.onChange(prevState.checkedUsers);
                        return prevState;
                    });
                }} name={record.user.account+"_"} checked={(()=>{
                    let res = false;
                    this.state.checkedUsers && this.state.checkedUsers.map(user=>{
                        if(record.user.account === user.account){
                            res = true;
                        }
                    });
                    return res;
                })()} />
            }
        },];

    componentWillMount() {
        this.setState({
            checkedUsers:this.props.checkedUsers
        });
        this.current = this.defaultStart;
        this.loadReporterList(this.current, 10, this.props.interviewId, this.props.searchReporterName, this.props.startDate, this.props.endDate, "", this.props.prop);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.prop !== this.props.prop || nextProps.searchReporterName!==this.props.searchReporterName){//如果属性还是之前的 或者 没有搜索内容，那就没必要再加载了
            this.current = this.defaultStart;
            this.setState({
                checkedUsers:nextProps.checkedUsers,
                data:[],
                total:0,
                over:false,
            });
            this.loadReporterList(this.current, 10, nextProps.interviewId, nextProps.searchReporterName, nextProps.startDate, nextProps.endDate, "", nextProps.prop);
        }else{
            this.setState({
                checkedUsers:nextProps.checkedUsers,
            });
        }
    }

    loadReporterList(start, size, interviewId, searchStr, startDate,endDate, checkedAccount, prop){
        this.setState({
            load:true
        });
        this.props.loadBegin();
        getReporterList(start, size, interviewId, searchStr, "true", "", startDate, endDate, checkedAccount, prop).then((res)=>{
            this.setState(prevState=>{
                this.props.loadOver();
                if((!res.data || res.data.length === 0)){
                    if(this.current!==1){
                        message.warn("到底啦，没有数据可以加载");
                    }else{
                        prevState.data = [];
                    }
                }else{
                    this.current ++;
                }
                return {
                    data: [...prevState.data, ...res.data],
                    total:res.count,
                    load:false,
                    over: (!res.data || res.data.length ===0)
                }
            })
        });
    }
    /*监听滚动*/
    onScroll = e => {
        if(this.state.load || this.state.over){//如果已经是在加载中或者已经没有数据加载了，就先不忙滚动
            return;
        }
        if(e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
            // 滚动到底部需要做的事情
            this.loadReporterList(this.current, 10, this.props.interviewId, "", this.props.startDate, this.props.endDate, "", this.props.prop);
        }
    };

    render() {
        return <div>
            <Row>
                {this.columns.map(column=>{
                    return <Col key={column.key} span={column.span} className={"newTableTitleText"}>{column.title}</Col>
                })}
            </Row>
            <Scrollbars style={{height:"450px"}} onScroll={this.onScroll} >
            {this.current === 1 && !this.state.load && (!this.state.data || this.state.data.length === 0)? <Empty style={{marginTop:"30px"}}/>:
                this.state.data.map((record, index)=>{
                    return <Row key={"row_"+index} className={"newTableContent"}>
                        {this.columns.map((column)=>{
                            let val = eval("record."+column.dataIndex);
                            return <Col title={val?val:""} style={{height:"77px"}} className={"newTableContentText " + column.className} key={"row_"+index+"_"+column.key} span={column.span}>
                                {column.render?column.render(record[column.dataIndex], record):record[column.dataIndex]}
                            </Col>
                        })}
                    </Row>
                })}
            {this.state.load ?<div style={{textAlign:"center",marginTop:"30px"}}><Spin/></div>:""}
            </Scrollbars>
            {/*<Table columns={this.columns} dataSource={this.state.data} pagination={false} />*/}
        </div>
    }
}
SelectReporterModalContent.defaultProps = {
    interviewId:0,
    startDate:window.formatDate(new Date()),
    searchStr:""
};

class SelectReporterBtn extends Component{
    render() {
        return <div style={{width: "100%", height: "100%", backgroundColor: "#ffffff", border: "dashed 1px #b2bbd5",
            cursor:"pointer",
            ...this.props.style,
            /*flex 布局*/
            display: "flex",
            /*实现垂直居中*/
            alignItems: "center",
            /*实现水平居中*/}} onClick={this.props.onClick}>
            <div style={{margin:"auto"}}>
                <img src={this.props.icon} style={{marginRight:"10px",marginTop:"-5px"}}/><span style={{width: "77px",
                height: "50px",
                fontFamily: "MicrosoftYaHei-Bold",
                fontSize: "16px",
                fontWeight: "normal",
                fontStretch: "normal",
                lineHeight: "50px",
                letterSpacing: "0px",
                color: "#a4adc8",}}>{this.props.name}</span>
            </div>
        </div>
    }
}
NewsActivitySelectReporter.defaultProps = {
    style:{},
    data:{},
}


function mapStateToProps(state){
    return {
        sysConfig : state.systemReducer.config,
    }
}
export default connect(mapStateToProps)(NewsActivitySelectReporter);